module.exports = __webpack_public_path__ + "img/GH-corporate-top002.734199cd.png";